import React from 'react';
import styled from 'styled-components';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';

import { Typo, Icon } from 'tmt-ui-kit';
import { mapMeetingPointToDetail } from '~/utils/trip';

const Container = styled.div`
  &:not(:last-child) {
    margin-bottom: 24px;
  }
  &:last-child {
    margin-bottom: 16px;
  }
`;

const TypeContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const MeetingPointIcon = styled(Icon)`
  margin-right: 8px;
  color: ${props => props.theme.darkBlue};
`;

const Title = styled(Typo.HeaderThree)`
  margin: 0px;
  font-size: 16px !important;
`;

const MeetingPoint = props => {
  const { points, type } = props;
  if (points.length === 0) return null;
  const label = mapMeetingPointToDetail(type);
  return (
    <Container>
      {type !== 'custom' && (
        <TypeContainer>
          <MeetingPointIcon name={type} />
          <Title>{pluralize(label, points.length)}</Title>
        </TypeContainer>
      )}
      <div>
        {points.map(point => <Typo.Paragraph key={point.name}>- {point.name}</Typo.Paragraph>)}
      </div>
    </Container>
  );
};

MeetingPoint.propTypes = {
  points: PropTypes.array,
  type: PropTypes.string
};

export default MeetingPoint;
